import React, { useMemo } from "react"
import { GridRowIdGetter, GridRowModel } from "@mui/x-data-grid-pro";
import DataGridColumnGenerator from "components/Common/DataGridColumnGenerator";
import useIsMobile from "helpers/hooks/useIsMobile";
import { useTheme } from "@mui/material";
import { useTranslations } from "@fenetech/translations";
import { IDashboardQuote } from "models/IDashboardQuote";
import useDashboardCustomerQuoteData from "./useDashboardCustomerQuoteData";
import useCurrencyFormatter from "helpers/hooks/useCurrencyFormatter";
import CustomDataGridPro from "components/Common/CustomDataGridPro";

const CustomerQuotesGrid: React.FC = () => {

    const tm = useTranslations();
    const theme = useTheme();
    const cf = useCurrencyFormatter();
    const data: IDashboardQuote[] | undefined = useDashboardCustomerQuoteData();
    const isMobile = useIsMobile();

    const getRowId: GridRowIdGetter = (row: GridRowModel) => {
        return row.oKey;
    }

    const columns = useMemo(() => {
        const generator = new DataGridColumnGenerator(tm, data, theme, isMobile, cf);
        
        generator.TryAddDocumentNumberColumn("oKey", "orderNumber", "Quote", "/quotes", { hideable: false });
        generator.TryAddTextColumn("salespersonName", "Salesperson", {});
        generator.TryAddWebCustomerColumn("webCenterCustomerName", "customerInactive", "Customer", {});
        generator.TryAddDateColumn("orderDate", "Date", {});
        generator.TryAddTextColumn("shippingName", "Shipping Name", {});
        generator.TryAddTextColumn("billingName", "Billing Name", {});
        generator.TryAddTextColumn("poNumber", "PO Number", {});
        generator.TryAddTextColumn("customerRef", "Customer Ref", {});
        
        generator.TryAddTotalPriceColumn({});
        generator.TryAddTotalPriceColumn({}, "totalCost", "Cost");
        
        generator.TryAddCheckColumn("submitted", "Submitted", { tooltip: null }, {});
        generator.TryAddTranslatedTextColumn("classificationDescription", "Status", {})
        generator.TryAddDateColumn("expirationDate", "Expires", {});

        return generator.GetColumns();
    }, [tm, data, theme, isMobile, cf]);

    return <>
        <CustomDataGridPro
            rows={data}
            columns={columns}
            getRowId={getRowId}
            tableName="DashboardCustomerQuote"
            tableSubName={isMobile ? "Mobile" : ""}
            hideByDefaultColumns={[
                "billingName"
            ]}
            hideInMobileColumns={[
                "webCenterCustomerName",
                "orderDate",
                "poNumber",
                "customerRef",
                "submitted",
                "shippingName",
                "salespersonName",
                "totalCost"
            ]}
        />
    </>;

};

export default CustomerQuotesGrid;